import React, { useState, useEffect } from 'react';
import { IconContext } from 'react-icons';
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaPhone,
  FaHeart,
} from 'react-icons/fa';
import {
  BsBoxArrowInUpRight,
} from 'react-icons/bs';
import { NavLink } from 'react-router-dom';
import styles from './footer.module.scss';
import logo from '../../assets/images/logo-accent.png';

const Footer = () => {
  const [year, setYear] = useState('');
  useEffect(() => {
    const date = new Date();
    const currentYear = date.getFullYear();
    setYear(currentYear);
  }, []);

  return (
    <footer className="Footer w-full flex flex-col items-center bg-neutral text-white mt-auto">
      <div
        className={`${styles.footer_wrapper} w-full flex items-center  gap-4`}
      >
        <div
          className={`${styles.footer_one} flex gap-2 md:border-l-[0.5px] border-current md:pl-4`}
        >
          <article>
            <h4 className="text-base pb-3 lg:text-2xl font-bold">
              Contactez-nous
            </h4>
            <ul className={`${styles.social_media_wrapper} leading-6 text-xs`}>
              <li className="flex items-center gap-3">
                <FaPhone />
                +243 000 000 000
              </li>
              <li className="flex items-center gap-3">
                <FaFacebook />
                Facebook
              </li>
              <li className="flex items-center gap-3">
                <FaTwitter />
                Twitter
              </li>
              <li className="flex items-center gap-3">
                <FaInstagram />
                Instagram
              </li>
              <li className="flex items-center gap-3">
                <FaYoutube />
                Youtube
              </li>
            </ul>
          </article>
          <article>
            <h4 className="text-base pb-3 lg:text-2xl font-bold">Liens</h4>
            <ul className="leading-6 text-xs">
              <li>
                <NavLink
                  to="/"
                  className="flex items-center gap-3 hover:text-secondary transition-colors"
                >
                  <BsBoxArrowInUpRight />
                  Accueil
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/"
                  className="flex items-center gap-3 hover:text-secondary transition-colors"
                >
                  <BsBoxArrowInUpRight />
                  À propos de nous
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/portfolio"
                  className="flex items-center gap-3 hover:text-secondary transition-colors"
                >
                  <BsBoxArrowInUpRight />
                  Réalisations
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/historique"
                  className="flex items-center gap-3 hover:text-secondary transition-colors"
                >
                  <BsBoxArrowInUpRight />
                  Historique
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  className="flex items-center gap-3 hover:text-secondary transition-colors"
                >
                  <BsBoxArrowInUpRight />
                  Contact
                </NavLink>
              </li>
            </ul>
          </article>
        </div>

        <div className={`${styles.footer_two} flex gap-2`}>
          <article className={styles.article_logo}>
            <div className={`${styles.logo}`}>
              <img loading="lazy" src={logo} className="" alt="Logo alternatif de COMITRA" />
            </div>
          </article>
          <article className={styles.article_content}>
            <h4 className="text-base pb-3 lg:text-2xl font-bold">
              À propos de nous
            </h4>
            <ul className="leading-6 text-xs">
              <p className="flex items-center p-2">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Neque
                facere laudantium magnam voluptatum autem. Amet aliquid nesciunt
                veritatis aliquam.
              </p>
            </ul>
          </article>
        </div>
      </div>

      <div
        className={`${styles.footer_copy_right} text-white flex justify-center items-center text-center`}
      >
        <p className="">
          Copyright &copy;
          {' '}
          {year}
          {' '}
          COMIGRA. Tous droits reserves |
        </p>
        <p className="flex justify-center items-center">
          Made with
          <IconContext.Provider value={{ className: 'px-1' }}>
            <FaHeart />
          </IconContext.Provider>
          by
          <a
            href="https://neutral.codes/"
            title="neutral"
            target="_blank"
            className="px-1"
            rel="noreferrer"
          >
            Neutral
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
